import {
  Editor,
  Transforms,
  Element as SlateElement
} from 'slate';

import types from '../../elements/types';

export function withFiles(editor) {
  const { insertBreak } = editor;

  editor.insertBreak = () => {
    const { selection } = editor;

    if (selection) {
      // Check if the selection is on a file block (a void node)
      const [fileBlock] = Editor.nodes(editor, {
        match(node) {
          return SlateElement.isElementType(node, types.HT_FILE);
        }
      });

      if (fileBlock) {
        const [, path] = fileBlock;

        // Insert a default block after the file block
        const nextBlockPath = Editor.after(editor, path);
        if (nextBlockPath) {
          // If there's a block after the current file block
          Transforms.insertNodes(editor, {
            type: types.DEFAULT, // Default block type (e.g., paragraph)
            children: [{ text: '' }],
          }, { at: nextBlockPath });
        } else {
          // If the file block is the last block, insert at the end
          Transforms.insertNodes(editor, {
            type: types.DEFAULT, // Default block type (e.g., paragraph)
            children: [{ text: '' }],
          });
        }

        return; // Prevent default insertBreak behavior for the file block
      }
    }

    // Fallback to default behavior if not a file block
    insertBreak();
  };

  return editor;
};